export const environment = {
  URL: 'https://uat-spriced-pas.alpha.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.simadvisory.com/auth',
  KEYCLOAK_REALM: 'SPRICED_NRP',
  KEYCLOAK_CLIENT_ID: 'SPRICED_NRP_CLIENT',
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  COMPANY_LOGO_SRC: "assets/image.png",
  COMPANY_LOGO_TEXT: "Pricing Action Simulator",
  HELP_ENABLED: "false",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "false",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  agentApiUrl: 'http://localhost:8081',
  platformApiUrl: 'https://uat-spriced-pas.alpha.simadvisory.com/spriced/platform',
};
